import { createApi } from '@reduxjs/toolkit/dist/query/react';

import serverRoutes from '@app/utils/server-routes';

import { baseQuery } from '@app/store/baseQuery';
import {
  QmAppealFillingObjectType,
  QmAppealFullObjectType,
  qmAppellationsBulkRequestType,
  qmAppellationsBulkResponseType,
} from '@app/interfaces/qm-module/qm-appellations/qm-appellations.type';

import { qmManageMonitoringTasksApi } from '../qm-manage/qm-manage-monitoring-tasks.api';

export const qmAppellationsApi = createApi({
  reducerPath: 'qmAppellationsApi',
  tagTypes: ['qm_appellations_list', 'qm_appeal_obj'],
  baseQuery: baseQuery,
  endpoints: (build) => ({
    getAppellationsListBulk: build.query<
      qmAppellationsBulkResponseType,
      qmAppellationsBulkRequestType | undefined
    >({
      query: (body) => ({
        url: serverRoutes.qm_appellations_bulk,
        body,
        method: 'POST',
      }),
      providesTags: ['qm_appellations_list'],
    }),
    fillAppeal: build.mutation<QmAppealFullObjectType, QmAppealFillingObjectType>({
      query: (body) => ({
        url: serverRoutes.qm_appellations,
        body,
        method: 'POST',
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(qmManageMonitoringTasksApi.util.invalidateTags(['monitoring_record']));
      },
      invalidatesTags: ['qm_appellations_list'],
    }),
    getAppealById: build.query<QmAppealFullObjectType, { appellation_id: string }>({
      query: (params) => ({
        url: serverRoutes.qm_appellations,
        params,
      }),
      providesTags: ['qm_appeal_obj'],
    }),
    changeAppealStatus: build.mutation<
      QmAppealFullObjectType,
      {
        params: { appellation_id: string };
        body: Pick<QmAppealFullObjectType, 'status' | 'resolution'>;
      }
    >({
      query: ({ params, body }) => ({
        url: serverRoutes.qm_appellations_status,
        params,
        body,
        method: 'PUT',
      }),
      invalidatesTags: ['qm_appeal_obj', 'qm_appellations_list'],
    }),
    approveOperator: build.mutation({
      query: (params: { id: string }) => ({
        url: serverRoutes.qm_monitoring_operator_approve,
        params,
        method: 'PUT',
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(qmManageMonitoringTasksApi.util.invalidateTags(['monitoring_record']));
      },
    }),
  }),
});
// qm/team/operator/bulk

export const {
  useGetAppellationsListBulkQuery,
  useFillAppealMutation,
  useLazyGetAppealByIdQuery,
  useGetAppealByIdQuery,
  useChangeAppealStatusMutation,
  useApproveOperatorMutation,
} = qmAppellationsApi;
